import Vue from 'vue'
import DefaultDialog from './src/main'
if (DefaultDialog) {
  DefaultDialog.install = (options) => {
    if (options.data.visible) {
      let div = document.getElementById('DefaultDialog')
      let div1 = document.querySelector('.sQDialog')
      let div2 = document.querySelector('.v-modal')
      if (div) {
        document.body.removeChild(div)
      }
      if (div1) {
        document.body.removeChild(div1)
      }
      if (div2) {
        document.body.removeChild(div2)
      }
      return
    }
    if (document.querySelector('.sQDialog')) {
      return
    }
    const AlterBox = Vue.extend(DefaultDialog)
    let instance = new AlterBox({
      ...options
    }).$mount()
    document.body.appendChild(instance.$el)
    Vue.nextTick(() => {
      instance.show = true
      // show 和弹窗组件里的show对应，用于控制显隐
    })
  }
}
export default DefaultDialog



// WEBPACK FOOTER //
// ./src/plugin/defaultDialog/index.js